var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrcSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 31,
    viewBox: "0 0 82 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1421 0.167419L15.5976 0.189064H10.8977L5.35318 0.21071H0.65332V8.1328H5.35318V4.88604H10.9194L10.941 25.3839H7.97384V30.0809L18.6081 30.0592V25.3839H15.6409L15.5976 4.8644H21.1638V7.95964H25.842V0.167419H25.8203H21.1421Z",
    fill: "#EA5B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.2262 17.1373H51.3128L51.2911 17.1157L54.8648 13.5226V3.58754L51.3345 0.124329H50.1216L37.2565 0.145974H32.5567H29.6328V4.84295H32.5567L32.6 25.3408H29.6328V30.0378H40.2671V25.3408H37.2999V17.159H46.548L48.8654 25.3192H47.0894V30.0162H50.1866H54.8864H57.7237V25.3192H53.5653L51.2478 17.1373H51.2262ZM50.1433 12.4404H37.2782V4.82131H50.1433V12.4404Z",
    fill: "#EA5B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M81.6991 7.85145V3.32763L78.4287 0.0808716H76.9992H66.2134L64.9788 0.102517L61.5352 3.56573V4.79949V8.04625L61.5568 16.2714V17.8948V25.2974V25.622L61.5785 26.5744L65.0005 29.9727H77.0425L78.5153 29.9511L81.7424 26.7476L81.7207 22.1805H77.0425V25.2757L66.2567 25.2974L66.235 8.02461L66.2134 4.77785H76.9992L77.0209 7.87309L81.6991 7.85145Z",
    fill: "#EA5B0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrcSmall);
export default __webpack_public_path__ + "static/media/TRC_Small.da5ade94d32f5f78205cf7d4c182933f.svg";
export { ForwardRef as ReactComponent };